<template>
  <div>
      <div id="gradientBar"></div>
      <HeaderCarousel></HeaderCarousel>
      <div id="gradientBar-reverse" style="margin-top: -1px;">
          <div class="row">
              <div class="col-md-3">
                  <img src="../src/assets/logo.png" alt="" class="img-fluid mt-1 mx-auto d-none d-lg-block" style="max-height: 100px;">
              </div>
              <div class="col-md-6">
                  <img src="../src/assets/whatsapp.png" alt="Whatsapp" class="logo-whatsapp"><br>
                  {{ $t('CONTACT_WHATSAPP') }}<br>
                  <span><a href='https://api.whatsapp.com/send?phone=352621251146&submit=Continue'>+352 621 251 146</a></span>
              </div>
              <div class="col-md-3 center-text">
                  <img src="../src/assets/logo.png" alt="" class="img-fluid mt-1 mx-auto d-none d-lg-block" style="max-height: 100px;">
              </div>
          </div>
      </div>
      <div class="container">
          <formContent></formContent>
      </div>

      <footerComponent></footerComponent>
  </div>
</template>

<script>
import HeaderCarousel from './components/header-carousel.vue'
import formContent from './components/form.vue'
import footerComponent from './components/footer.vue'

export default {
  name: 'app',
  components: {
      HeaderCarousel,
      formContent,
      footerComponent
  }
}
</script>
